<div class="container mx-auto">
  <!-- Section Header -->
  <div
    class="flex flex-wrap items-center justify-between mb-4 sm:mb-6 pb-3 sm:pb-4 border-b border-base-300"
  >
    <div class="flex-1">
      <h2
        class="text-xl sm:text-2xl font-bold text-base-content flex items-center gap-2"
      >
        <i
          class="fa-solid fa-graduation-cap text-primary text-xl sm:text-2xl shrink-0"
        ></i>
        <span>My Courses</span>
      </h2>
      <p class="text-xs sm:text-sm text-base-content/60 mt-1">
        Access your on-demand video lectures, study materials, and track your
        progress
      </p>
    </div>
  </div>

  <!-- Card grid, skeleton or empty state -->
  @if (isLoading) {
    <div
      class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-6"
    >
      @for (i of [1, 2, 3, 4]; track i) {
        <div
          class="daisy-card daisy-card-bordered bg-base-100 shadow-sm border-base-300 overflow-hidden h-full flex flex-col"
        >
          <div class="daisy-skeleton aspect-video w-full rounded-none"></div>
          <div
            class="daisy-card-body p-4 sm:p-5 flex-1 flex flex-col justify-between gap-3"
          >
            <div class="flex flex-col gap-2">
              <div class="daisy-skeleton h-3.5 w-1/3"></div>
              <div class="daisy-skeleton h-5 w-3/4"></div>
              <div class="daisy-skeleton h-3.5 w-full"></div>
              <div class="daisy-skeleton h-3.5 w-2/3"></div>
              <div class="flex gap-3 pt-2 border-t border-base-200 mt-1">
                <div class="daisy-skeleton h-3.5 w-16"></div>
                <div class="daisy-skeleton h-3.5 w-16"></div>
              </div>
            </div>
            <div class="pt-3 border-t border-base-200">
              <div class="daisy-skeleton h-8 w-full rounded-lg"></div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else if (courseItems.length > 0) {
    <div
      class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-6"
    >
      @for (item of courseItems; track item.course._id) {
        <div class="h-full">
          <black-course-card
            [course]="item.course"
            [isEnrolled]="item.isEnrolled"
            [enrollmentStatus]="item.enrollmentStatus"
            [orderId]="item.orderId"
            (cardClicked)="onCourseClick($event)"
          ></black-course-card>
        </div>
      }
    </div>
  } @else {
    <div class="flex flex-col items-center justify-center py-16">
      <p class="mb-6 text-lg text-gray-600">
        Your course list is currently empty.
      </p>
      <button class="daisy-btn daisy-btn-primary gap-2" routerLink="/courses">
        <i class="fa-solid fa-compass"></i>
        Explore Courses
      </button>
    </div>
  }
</div>
